<template>

  <div class="hello flex_c" style="width: 100%;height: 100%">
    <div style="width: 100%;height: 100%;background-color: White;padding: 0 35px 0 35px">

      <div class="row top" >
        <div  style="text-align: left;font-size: 20px">绑定手机号</div>
      </div>

      <el-form ref="form" v-if="openid" :model="form" label-width="60px" style="margin-top: 80px">

        <el-form-item label="手机号">
          <el-input v-model="phone"></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <div class="flex_s">
            <el-input v-model="sms_code" style="width: calc(100% - 130px)"></el-input>
            <el-button style="width: 120px" type="primary" @click="sendSms()">{{btn1}}</el-button>
          </div>
        </el-form-item>

        <el-button class="bind" type="primary" @click="bindBtn()">立即绑定</el-button>

      </el-form>

    </div>

  </div>

</template>

<script>

  export default {
    name: 'wxBindPhone',
    data() {
      return {
        openid: '',
        collegeId: '',
        form: {
          no: '',
          psw: '',
          new_password: ''
        },
       phone: '',
       sms_code: '',
        index: 60,
        timer: null,
        btn1: '发送验证码'
      }
    },
    created() {
      if (this.$route.query.openid) {
        this.openid = this.$route.query.openid
      }
      if (this.$route.query.collegeId) {
        this.collegeId = this.$route.query.collegeId
      }
      if (this.$route.query.no) {
        this.form.no = this.$route.query.no
      }
      if (this.$route.query.psw) {
        this.form.psw = this.$route.query.psw
      }
      if (this.$route.query.new_password) {
        this.form.new_password = this.$route.query.new_password
      }
    },
    methods: {
      bindBtn() {
        if (!this.collegeId) {
          alert('获取高校错误')
          return false
        }
        if (!this.collegeId) {
          alert('获取高校错误')
          return false
        }
        if (!this.openid) {
          alert('授权错误')
          return false
        }
        if (!this.form.no) {
          alert('学号错误')
          return false
        }
        if (!this.form.psw) {
          alert('密码错误')
          return false
        }
        if (!this.phone) {
          alert('手机号错误')
          return false
        }
        if (!this.sms_code) {
          alert('验证码错误')
          return false
        }
        // checkPhoneWithCode

        let data = {
          mobile: this.phone,
          vcode_text: this.sms_code
        }
        this.$api.checkPhoneWithCode(data)
          .then(res => {
              this.bindMethed()
          }).catch(e => {
          if (e.Errmsg) {
            this.toast.err(e.Errmsg)
          }
        })
      },
      bindMethed() {
        let data = {
          login_type: 'no',
          collegeid: this.collegeId,
          no: this.form.no,
          password: this.form.psw,
          new_password: this.form.new_password,
          account_type: 'talent',
          wechat_bind: {
            openid: this.openid
          },
          mobile: this.phone
        }
        this.$api.accountLogin(data)
          .then(res => {
            if(res) {
              this.getToken(res.value)
            }
          }).catch(e => {
          if (e.Errmsg) {
            this.toast.err(e.Errmsg)
          }
        })

      },
      getToken(code) {
        let data = {
          'grant_type': 'authorization_code',
          'code': code,
          'refresh_token': '',
          'loginname': '',
          'password': '',
          'login_source': ''
        }
        this.$api.getToken(data).then(res => {
          if (res) {
            localStorage.setItem('accesstoken',res.access_token)
            this.$api.getTalentUser(data).then(res => {
              if (res) {
                console.log('getTalentUser',res)
                this.toast.success('绑定成功')
                this.$router.push('/bindSuccess')
              }
            }).catch(e => {
              if (e.Errmsg) {
                this.toast.err(e.Errmsg)
              }
            })
          }
        }).catch(e => {
          if (e.Errmsg) {
            this.toast.err(e.Errmsg)
          }
        })
      },
      sendSms() {
        if (this.btn1 !== '发送验证码') {
          this.toast.err(this.index + '后发送')
          return
        }
        if (!this.phone) {
          alert('手机号错误')
          return false
        }
        let data = {
          value: this.phone
        }
        this.$api.sendSms(data).then(res => {
          this.toast.success('发送成功')
          this.startTime()
        }).catch(e => {
          if (e.Errmsg) {
            this.toast.err(e.Errmsg)
          }
        })
      },
      startTime() {
        this.index = 60
        let time = setInterval(() => {
          this.index -= 1
          this.btn1 = this.index + 's'
          if (this.index <= 0) {
            clearInterval(time)
            this.index = 60
            this.btn1 = '发送验证码'
          }
        }, 1000)
      }
    }
  }
</script>

<style scoped>
  .top
  {
    margin-top: 55px;
  }
  .bind {
    width: 250px;
    margin-left: calc((100% - 250px)/2);
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/wxBindPhone.vue